// Our placeholder image is 600px x 331px and exactly 8267 bytes large
// Our placeholder image is 600px x 331px and exactly 8267 bytes large
const PLACEHOLDER_IMG_DIMENSIONS = {width: 600, height: 331};
const PLACEHOLDER_IMG_FILESIZE_BYTES = 8267;
    
/**
* 
* Retrieves the true width, height and size of an image given it's source url
* @param src - The source URL of the image.
* @returns A Promise that resolves to an object containing:
*   - width: The true ("intrinsic") width of the image in pixels.
*   - height: The true ("intrinsic") height of the image in pixels.
*   - size: The file size of the image in bytes.
*
*
*/
const getImageData = async(src) => {
    return new Promise(async (resolve, reject) => {
        const img      = new window.Image();
        const response = await fetch(src);
        const blob     = await response.blob();

        // Create a callback for the image's 'onload' event 
        img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight, size: blob.size });
        img.onerror = reject;

        // This line is CRITICAL, as the image will not load until you assign the image object a source
        // thus, the onload callback will never fire
        img.src = src;       
    })
};


/**
 * 
 * Retrieves the data for an array of images and determines whether they are 'Anytime booking' ugly grey placeholders
 * @param array an array of image source strings 
 * @returns an array of usable images
 * 
 * 
 * Retrieves the data for an array of images and determines whether they are 'Anytime booking' ugly grey placeholders
 * @param array an array of image source strings 
 * @returns an array of usable images
 * 
 */
export const getUsableImages = async(images = []) => {
    const arr = await Promise.all(
        images.map(async (imageSrc) => {  
            const imgDataObj = await getImageData(imageSrc);

            // compare the retrieved image blob's properties with those of a ugly grey placeholder image to determine usability
            const isPlaceholder =
                imgDataObj.size === PLACEHOLDER_IMG_FILESIZE_BYTES ||
                (imgDataObj.width === PLACEHOLDER_IMG_DIMENSIONS.width &&
                imgDataObj.height === PLACEHOLDER_IMG_DIMENSIONS.height);

            // is considered "usable" if it is not an ugly grey placeholder image
            const isUsable = !isPlaceholder;

            return { imageSrc, isUsable };                
        })
    )

    // return a filtered array of usable images 
    return arr.filter(image => image.isUsable);        
}